"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  canNotUseSameNetworks: 'Вы не можете использовать одну и туже социальную сеть для входа в один и тот же Объект под разными ролями',
  useAnotherNetwork: 'Используйте другую соц. сеть или email для регистрации нового аккаунта в новой роли',
  registrationNotPossible: 'Регистрация невозможна. Эта соцсеть уже зарегистрирована в данном Объекте.'
};